import { render, staticRenderFns } from "./UserCalendarView.vue?vue&type=template&id=647f9666&scoped=true&lang=pug&"
import script from "./UserCalendarView.vue?vue&type=script&lang=js&"
export * from "./UserCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./UserCalendarView.vue?vue&type=style&index=0&id=647f9666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f9666",
  null
  
)

export default component.exports